/**
 * =============================================================================
 * setera-web
 * =============================================================================
 * Copyright (c) 2026 HG Digital/Setera
 * Todos os direitos reservados.
 *
 * Este software é confidencial e de propriedade da HG Digital/Setera.
 * Seu uso está sujeito aos termos do contrato de licença.
 * -----
 * Criado em : 2026-07-23 09:35:54
 * Autor : Diego Brock
 * Projeto : setera-web
 * Versão : 1.0.0
 * =============================================================================
 */

import { PerfilCommandActionInterface } from "../contracts/PerfilCommandAction.interface";

/**
 * Model de vínculo perfil × command_action e paths da API base.
 */
export class PerfilCommandAction implements PerfilCommandActionInterface {
  /** CRUD base: /perfil-command-action */
  nomeConsultaApiBase = "perfil-command-action";

  /** Lista vínculos do perfil: /perfil-command-action/list?perfilId= */
  listConsultaApiBase = "perfil-command-action/list";

  /**
   * Sync bulk: PUT /perfil-command-action/perfil/{perfilId}/sync
   * Usar com putByUrl: `${syncConsultaApiBase}/${perfilId}/sync`
   */
  syncConsultaApiBase = "perfil-command-action/perfil";

  /** Catálogo: GET /command-actions */
  catalogoConsultaApiBase = "command-actions";

  uuid: string;
  ativo: boolean;
  commandAction: string;
  commandActionDescription?: string;
  perfilId: number;
  nmPerfil?: string;
}
